import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import EmployeeDivisionModel from '../../../models/EmployeeDivisionModel';
import DataService from "../../../services/data.service";
import AddDivisionPopup from '../Popups/Employee_popup_AddDivision';

interface Props {
    employeeId: number
}

const Employee_tab_Divisions: React.FC<Props> = ({ employeeId }) => {
    const [data, setData] = useState<EmployeeDivisionModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [employeeId]);

    function getTableData() {
        DataService.get<EmployeeDivisionModel[]>('api/v1/EmployeeDivisions/ByEmployee/' + employeeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/EmployeeDivisions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'divisionId', visible: false },
        { title: 'Division', dataProp: 'division.name', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EmployeeMaintenance)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtEmployeeDivisions'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Division'
                navigateUrl='/plm/UserManagement/Division/'
            />
            {showPopup && (<AddDivisionPopup employeeId={employeeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />)}

        </>
    );
}
export default Employee_tab_Divisions;